export const FAILURE = 'FAILURE'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOG_OUT = 'LOG_OUT'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'